(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('checkboxArray', checkboxArray);

    /* @ngInject */
    function checkboxArray() {
        var directive = {
            bindToController: true,
            templateUrl: 'checkbox-array.tpl',
            controller: checkboxArrayController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                fieldModel: '=ngModel',
                choices: '<',
                preId: '<'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            if (angular.isUndefined(scope.vm.fieldModel)) {
                scope.vm.fieldModel = [];
            } else if (!angular.isArray(scope.vm.fieldModel)) {
                var t = [];
                for(var k in scope.vm.fieldModel) {
                    if (scope.vm.fieldModel[k]) {
                        t.push(k);
                    }
                }
                scope.vm.fieldModel = t;
            }
        }
    }
    /* @ngInject */
    function checkboxArrayController ($scope) {
        $scope.makeChoice = function(idx) {
            var clickedVal = $scope.vm.choices[idx].value;
            var modelIndex = $scope.vm.fieldModel.indexOf(clickedVal);

            if (modelIndex == -1) {
                $scope.vm.fieldModel.push($scope.vm.choices[idx].value);
            } else {
                $scope.vm.fieldModel.splice(modelIndex, 1);
            }
        };
    }
})();